import { request } from '@umijs/max';

/** 查询抽取自定义nlp节点标注任务列表 */
export const getNlpNodeAnnotationTaskOverview = async ({
  template_code,
  node_uid,
}: {
  template_code: string;
  node_uid?: string;
}) => {
  const res = await request<
    IRes<
      {
        node_name: string;
        create_time: string;
        annotated_progress: number;
        annotated_count: number;
        un_annotated_count: number;
        annotated_task_id: number;
      }[]
    >
  >(
    `/supertext-java/extraction/template/nlp/annotation/task/list/${template_code}`,
    {
      params: {
        node_uid: node_uid,
      },
    },
  );

  return res.data;
};
getNlpNodeAnnotationTaskOverview.queryKey = (params: {
  template_code: string;
  node_uid?: string;
}) => [
  {
    method: 'GET',
    url: `/supertext-java/extraction/template/nlp/annotation/task/list/${params.template_code}`,
    params: {
      node_uid: params.node_uid,
    },
  },
];

/** 创建nlp节点标注任务 */
export const createNlpNodeAnnotationTask = async (data: {
  template_code: string;
  node_uid: string;
}) => {
  const res = await request<IRes<number>>(
    '/supertext-java/extraction/template/nlp/annotation/task',
    {
      method: 'POST',
      data,
    },
  );
  return res.data;
};

const TrainMap = {
  start: 1,
  stop: 0,
} as const;

/** nlp节点 模型训练 */
export const createNlpNodeTrainingResult = async (data: {
  template_code: string;
  node_uid: string;
  train: keyof typeof TrainMap; // 0:停止训练 1:开始训练
}) => {
  const res = await request<IRes<number>>(
    '/supertext-java/extraction/template/nlp/train',
    {
      method: 'POST',
      data: {
        ...data,
        train: TrainMap[data.train],
      },
    },
  );
  return res.data;
};
